;(function () {
  angular.module('contrast.filters').filter('getCustom', function () {
    return function (data) {
      var result = []
      if (typeof data === 'undefined') {
        return result
      }
      if (data.length == 0) {
        return result
      }

      for (var i = 0; i < data.length; i++) {
        var item = data[i]
        if (item.custom) {
          result.push(item)
        }
      }

      return result
    }
  })
})()
